// src/components/Loader.js
import React from "react";
import "./css/Loader.css"; // Import the CSS for styling

const Loader = () => {
  return <div className="loader-container">
          <div className="loader"></div>
        </div>;
};

export default Loader;